import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { Utils } from 'src/app/core/resources/utils';
import { Global } from 'src/app/core/resources/global';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AccountService } from 'src/app/modules/account/account.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { User } from 'src/app/core/interfaces/user';
import { UserState } from 'src/app/core/enums/user-state.enum';
import { StateUserPipe } from 'src/app/core/pipe/stateInactive.pipe';
import { AdminUsersService } from 'src/app/modules/administration/admin-users/admin-users.service';
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { OpenDetailManifestsComponent } from 'src/app/modules/cargo/open-detail-manifests/open-detail-manifests.component';
import { ModalEnum } from 'src/app/core/enums/modal.enum';
import { Vehicle } from 'src/app/core/interfaces/vehicle';
import { RelatedInfoUser } from 'src/app/core/interfaces/relatedInfoUser';
import { UserFormComponent } from 'src/app/modules/administration/admin-users/user-form/user-form.component';
import { VehiclesService } from 'src/app/modules/administration/vehicles/list-vehicles.service';
import { ChangeDriverComponent } from 'src/app/modules/cargo/change-driver/change-driver.component';
import { FormControl } from '@angular/forms';
import { RoleUser } from 'src/app/core/interfaces/roleUser';
import { Roles } from 'src/app/core/enums/roles.enum';
import { VehicleManager } from 'src/app/core/managers/vehicle.manager';
import { SetAdministratorComponent } from 'src/app/modules/administration/vehicles/set-administrator/set-administrator.component';
import { AuthService } from 'src/app/core/services/authentication.service';
import { environment } from 'src/environments/environment';
import { VehicleCreate } from 'src/app/core/interfaces/vehicleCreate';
import { HttpErrorResponse } from '@angular/common/http';
import { UserValidate } from 'src/app/core/interfaces/userValidate';
import { UserManager } from 'src/app/core/managers/user.manager';
import { PermissionRole } from 'src/app/core/resources/permission-role';
import { Permission } from 'src/app/core/resources/permission';
import { FormMessages } from 'src/app/core/messages/form-messages.enum';
import { DuplicatedPhoneComponent } from 'src/app/modules/administration/vehicles/duplicated-phone/duplicated-phone.component';
import { merge } from 'rxjs';
import { ServiceMessages } from 'src/app/core/messages/service-messages.enum';

@Component({
  selector: 'app-user-card',
  templateUrl: './user-card.component.html',
  styleUrls: ['./user-card.component.scss'],
  providers: [VehicleManager, UserManager]
})
export class UserCardComponent implements OnInit {

  @Input() public user: User;
  @Input() public relatedInfo: RelatedInfoUser = {
    driver: {},
    owner: {},
    vehicle: {
      truora: undefined
    },
  };
  @Input() public validateTruora: boolean = true;
  @Input() public role: RoleUser;
  @Input() public disabledEdit: boolean = true;
  @Input() public canEditCardBySecurityStudies: boolean = true;
  @Output() onEdit: EventEmitter<any> = new EventEmitter();
  public roles = Roles;
  permission = Permission;
  userStateByValidationRules: { active: boolean, description: string } = { active: false, description: '' };
  public loadingProfilePic: boolean = false;
  public storeProfilePic: string = '';
  constructor(
    public utils: Utils,
    public global: Global,
    public accountService: AccountService,
    public spinner: NgxSpinnerService,
    private stateUserPipe: StateUserPipe,
    private adminUserService: AdminUsersService,
    private snackBarService: SnackBarService,
    public dialog: MatDialog,
    private vehiclesService: VehiclesService,
    private vehicleManager: VehicleManager,
    public authService: AuthService,
    private userManager: UserManager,
    private permissionRole: PermissionRole,
  ) {
  }

  ngOnInit() {
  }

  async ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.relatedInfo && changes.relatedInfo.currentValue) {
      if (changes && changes.relatedInfo && changes.relatedInfo.currentValue && changes.relatedInfo.currentValue.driver) this.relatedInfo.driver = this.userManager.sanitizeUser(changes.relatedInfo.currentValue.driver, this.roles.DRIVER);

      if (changes && changes.relatedInfo && changes.relatedInfo.currentValue && changes.relatedInfo.currentValue.owner) this.relatedInfo.owner = this.userManager.sanitizeUser(changes.relatedInfo.currentValue.owner, this.roles.OWNER);

    }
    if (changes && changes.user && changes.user.currentValue) {
      this.userStateByValidationRules = await this.adminUserService.getUserStateByValidationRules(this.user, this.role);
    }
    if (changes && changes.user && changes.user.currentValue && changes.user.currentValue.profilePicture) {
      this.getURlPictureUser(changes.user.currentValue.profilePicture);
    }
  }

  public openManifests(): void {
    const dialogConfig = new MatDialogConfig();
    const title = `Manifiestos asociados`;
    dialogConfig.data = {
      title: title,
      manifest: this.user.manifests,
      driverName: this.user.information.name
    };
    dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.autoFocus = false;
    this.dialog.open(OpenDetailManifestsComponent, dialogConfig);
  }

  public openDetailUser(): void {
    this.user.role = this.role;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      driver: this.user,
      expireArl: !!this.relatedInfo.expireArl,
      expireEps: !!this.relatedInfo.expireEps,
      showDocuments: this.authService.getCompany().companyId === environment.rootNit ? this.showCheckValidationIndividual : this.showCheckValidation,
      driverIsSameOwner: this.relatedInfo && this.relatedInfo.vehicle && this.relatedInfo.vehicle.driver && this.relatedInfo.vehicle.driver.document && this.relatedInfo.vehicle.owner && this.relatedInfo.vehicle.owner.document === this.relatedInfo.vehicle.driver.document,
      ownerIsSameAdmin: this.relatedInfo && this.relatedInfo.vehicle && this.relatedInfo.vehicle.administrator && this.relatedInfo.vehicle.administrator.document && this.relatedInfo.vehicle.owner && this.relatedInfo.vehicle.owner.document === this.relatedInfo.vehicle.administrator.document,
      validateTruora: this.validateTruora,
      role: this.role
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.LARGE_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(UserFormComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      this.getDetailDriver(true);
    });
  }

  public changeDriver(): void {
    const owner = this.utils.getNestedValue(this.relatedInfo, 'vehicle.owner');
    const licensePlate = this.utils.getNestedValue(this.relatedInfo, 'vehicle.id');
    if (!owner || !licensePlate) {
      this.openEditVehicle();
    } else {
      const formControl = new FormControl();
      const dialogConfig = new MatDialogConfig();
      dialogConfig.data = {
        title: 'Modificación de conductor',
        label: 'Ingresa el número de documento',
        idVehicle: licensePlate,
        options: {
          typeUser: 'driver',
        },
        inputFormControl: formControl
      };
      dialogConfig.width = ModalEnum.EXTRA_SMALL_WIDTH;
      dialogConfig.autoFocus = false;
      dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
      const modalDialog = this.dialog.open(ChangeDriverComponent, dialogConfig);
      modalDialog.afterClosed().subscribe(result => {
        if (result && result.state && result.data) {
          this.vehicleChangeDriver(result.data, result.securityStudyValidation);
        }
      });
    }
  }

  private userValidate(): void {
    this.spinner.show();
    const data: UserValidate = {
      forceCreation: true,
      vehicle: this.relatedInfo.vehicle,
      driver: {},
      owner: {}
    };

    if (this.utils.isDefined(this.relatedInfo.trailer)) {
      data.trailer = this.relatedInfo.trailer;
    }

    if (this.role === Roles.DRIVER) {
      data.driver = this.user;
      data.owner = this.relatedInfo.owner;
      if (this.relatedInfo.administrator)
        data.administrator = this.relatedInfo.administrator;
    }
    if (this.role === Roles.OWNER) {
      data.owner = this.user;
      data.driver = this.relatedInfo.driver;
      if (this.relatedInfo.administrator)
        data.administrator = this.relatedInfo.administrator;
    }
    if (this.role === Roles.ADMIN) {
      data.administrator = this.user;
      data.driver = this.relatedInfo.driver;
      data.owner = this.relatedInfo.owner;
    }

    data.driver.phone = data.driver.phone && data.driver.phone.startsWith("57")
      ? data.driver.phone
      : `57${data.driver.phone}`;
    data.owner.phone = data.owner.phone && data.owner.phone.startsWith("57")
      ? data.owner.phone
      : `57${data.owner.phone}`;

    this.vehiclesService.createVehicleDriverOwner(data).subscribe(
      (success: VehicleCreate) => {
        this.spinner.hide();
        if (
          !this.utils.isEmpty(success) &&
          !this.utils.isEmpty(success.message)
        ) {
          this.snackBarService.openSnackBar(success.message);
        } else {
          this.snackBarService.openSnackBar(
            "Estudio de seguridad realizado correctamente, puede tardar unos minutos",
            undefined,
            "success"
          );
        }
        setTimeout(() => {
          this.onEdit.emit(this.relatedInfo.vehicle.id);
        }, 400);
      },
      (error: HttpErrorResponse) => {
        this.spinner.hide();
        if (error && error.status && error.error && error.error.message &&
          error.status === 400 && error.error.message === FormMessages.REPEATED_DRIVER_PHONE)
          this.duplicatePhoneErrorManagement(data);
        else if (
          !this.utils.isEmpty(error) &&
          !this.utils.isEmpty(error.error) &&
          !this.utils.isEmpty(error.error.message)
        ) {
          this.snackBarService.openSnackBar(
            error.error.message,
            undefined,
            "alert"
          );
        } else {
          this.snackBarService.openSnackBar(
            "Ocurrió un error al realizar el estudio de seguridad",
            undefined,
            "error"
          );
        }
      }
    );
  }

  private duplicatePhoneErrorManagement(data: UserValidate) {
    const phones = {
      driver: !!data.driver ? (!!data.driver.phone ? data.driver.phone : null) : null,
      owner: !!data.owner ? (!!data.owner.phone ? data.owner.phone : null) : null,
      administrator: !!data.administrator ? (!!data.administrator.phone ? data.administrator.phone : null) : null,
    }
    const observables = [];
    const subjects = ['driver', 'owner', 'admin'];
    subjects.forEach(subject => {
      if (!!phones[subject]) {
        const singlePhone = this.vehiclesService.removeCountryCode(phones[subject]);
        const countryPhone = this.vehiclesService.addCountryCode(phones[subject]);
        observables.push(
          this.vehiclesService.getUsersByPhone(singlePhone),
          this.vehiclesService.getUsersByPhone(countryPhone)
        );
      }
    })
    const results: User[] = [];
    merge(...observables).subscribe(
      {
        next: (users: User[]) => {
          if (Array.isArray(users))
            results.push(...users);
        },
        error: (error: Error) => {
          console.error(error);
        },
        complete: () => {
          const documents = [];
          const findedUsers = results.filter(user => {
            const document = user.information.document;
            const distinct = documents.indexOf(document) === -1;
            documents.push(document);
            return distinct;
          });
          this.showDuplicatedPhoneDialog(findedUsers);
        }
      }
    );

  }

  /**
  * @param {User[]} users is the list of users with the same phone number
  * @description Shows a modal to update the users with same phone number
  */
  public showDuplicatedPhoneDialog(users: User[]): void {
    const config: MatDialogConfig = {
      data: users
    };
    config.maxHeight = ModalEnum.MAX_HEIGHT;
    config.maxWidth = ModalEnum.MAX_WIDTH;
    config.width = ModalEnum.LARGE_WIDTH;
    config.autoFocus = false;
    this.dialog.open(DuplicatedPhoneComponent, config);
  }


  checkCompanyConditions() {
    if (this.authService && this.authService.getCompanySaaS() && this.authService.getCompanySaaS().allowCreatingWithoutTruora) this.stateCheck();
    else this.checkValidationUser();
  }

  public checkValidationUser(): void {
    if ((this.relatedInfo && this.relatedInfo.vehicle && !this.relatedInfo.vehicle.checkId)) {
      this.userValidate();
    } else if (this.user && (!this.user.truora || !this.user.truora.checkId)) {
      this.checkValidationIndividual();
    } else {
      if (this.user && this.user.information && this.user.information.document) {
        this.stateCheck();
      } else {
        this.snackBarService.openSnackBar('No fue posible acceder al documento del usuario', undefined, 'error');
        this.getDetailDriver();
      }
    }
  }


  private stateCheck() {
    if (this.relatedInfo && this.relatedInfo.vehicle && this.relatedInfo.vehicle.checkId && this.user && this.user.truora && this.user.truora.checkId && this.relatedInfo.vehicle.checkId === this.user.truora.checkId) this.sameCheckVehicleUser();
    else if (this.user && this.user && this.user.truora && this.user.truora.checkId) this.checkOnlyuser();
    else this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');
  }

  private sameCheckVehicleUser() {
    const driverDetail: User = this.utils.clone(this.user);
    delete driverDetail.profilePictureUrl;
    this.spinner.show();
    const $sub = this.adminUserService.checkValidationUser(driverDetail.information.document).subscribe(
      {
        next: async (success: { driver: User }) => {
          const driver = success && success.driver ? success.driver : null;
          const { active, errors } = await this.adminUserService.isEnabledByValidationRules(driver, 'Driver');
          let documentsToValidate = errors
            .filter(error => /arl|eps/i.test(error))
            .map(error => error.toLowerCase().includes('arl') ? 'arl' : 'eps');
          if (!driver)
            this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');
          else if (!active) {
            if (driver.role) driver.role = this.role;
            this.adminUserService.confirmDriverInactive(driver, this.relatedInfo.vehicle, documentsToValidate);
          }
          this.getDetailDriver();
          this.spinner.hide();
        },
        error: () => {
          this.snackBarService.openSnackBar('Ocurrió un error con la petición', undefined, 'error');
          this.getDetailDriver();
          this.spinner.hide();
        },
        complete: () => {
          $sub.unsubscribe();
        }
      }
    )
  }

  private checkOnlyuser() {

    const checkOnlyUserObserver = {
      next: (success: User) => {
        // this.spinner.hide();
        this.snackBarService.openSnackBar(FormMessages.USER_VALIDATION_SUCCESS, undefined, 'success');
      },
      error: () => {
        this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');
        // this.spinner.hide();
      },
      complete: () => {
        this.spinner.hide();
        this.getDetailDriver();
      }
    }
    this.spinner.show();
    this.adminUserService.checkOnlyUser(this.user.information.document).subscribe(checkOnlyUserObserver)
  }

  private checkValidationIndividual(): void {
    const user: User = this.utils.clone(this.user);
    delete user.profilePictureUrl;
    if (user && user.information && user.information.document) {
      this.spinner.show();
      const $sub = this.adminUserService.checkValidationIndividual(user).subscribe(
        {
          next: async (success: { driver: User }) => {
            const driver = success && success.driver ? success.driver : null;
            const { active, errors } = await this.adminUserService.isEnabledByValidationRules(driver, 'Driver');
            let documentsToValidate = errors
              .filter(error => /arl|eps/i.test(error))
              .map(error => error.toLowerCase().includes('arl') ? 'arl' : 'eps');
            if (!driver)
              this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');
            else if (!active) {
              if (driver.role) driver.role = this.role;
              this.adminUserService.confirmDriverInactive(driver, this.relatedInfo.vehicle, documentsToValidate);
            }
            this.getDetailDriver();
            this.spinner.hide();
          },
          error: () => {
            this.snackBarService.openSnackBar('Ocurrió un error con la petición', undefined, 'error');
            this.getDetailDriver();
            this.spinner.hide();
          },
          complete: () => {
            $sub.unsubscribe();
          }
        }
      )
    } else {
      this.snackBarService.openSnackBar('No fue posible acceder al documento del usuario', undefined, 'error');
      this.getDetailDriver();
    }
  }

  public openEditVehicle(): void {
    if (!this.canEditCardBySecurityStudies) {
      this.snackBarService.openSnackBar('No se puede editar durante un estudio de seguridad en proceso', undefined, 'alert');
      return;
    }

    const userDescription = this.utils.getNestedValue(this.user, 'state.description');
    if (userDescription === 'Pending') {
      this.snackBarService.openSnackBar(FormMessages.NOT_ALLOWED_EDIT_USER, undefined, 'alert');
      return;
    }

    if (this.role === Roles.ADMIN) {
      this.openEditAdministrator();
    } else {
      this.vehicleManager.updateInformation(this.relatedInfo.vehicle).subscribe(
        (success) => {
          this.onEdit.emit(this.relatedInfo.vehicle.id);
        },
        (error) => {
        }
      );
    }
  }

  public openEditAdministrator(): void {

    if (!this.canEditCardBySecurityStudies) {
      this.snackBarService.openSnackBar('No se puede asignar administrador durante un estudio de seguridad en proceso', undefined, 'alert');
      return;
    }

    if (!this.canEditAdmin) {
      this.snackBarService.openSnackBar("No tienes permisos para realizar esta acción", undefined, 'alert');
      return;
    }

    const config = new MatDialogConfig();
    config.data = {
      licensePlate: this.relatedInfo.vehicle.id,
      hasAdministrator: !!this.relatedInfo.vehicle.hasAdministrator,
      administrator: this.user,
      title: 'Asignar Administrador'
    };
    config.maxHeight = ModalEnum.MAX_HEIGHT;
    config.maxWidth = ModalEnum.MAX_WIDTH;
    config.autoFocus = false;
    const ref = this.dialog.open(SetAdministratorComponent, config);
    ref.afterClosed().subscribe(
      (vehicle: Vehicle) => {
        this.onEdit.emit(this.relatedInfo.vehicle.id);
      }
    )
  }

  private async getURlPictureUser(profilePicture?: string) {
    if (profilePicture && this.user.profilePicture === profilePicture && this.storeProfilePic) return this.user.profilePictureUrl = this.storeProfilePic;
    if (this.utils.isDefined(this.user) && this.utils.isDefined(this.user.profilePicture)) {
      this.loadingProfilePic = true;
      try {
        const profilePicture = await this.adminUserService.searchResourceDynamicallyAmongCompanies(this.user.profilePicture, null, null, true);
        if (profilePicture && profilePicture.url) {
          this.storeProfilePic = profilePicture.url;
          this.user.profilePictureUrl = this.storeProfilePic;
        }
      } catch (error) {
        console.error("error getting profile picture", error)
      } finally {
        this.loadingProfilePic = false;
      }
    }
  }

  private vehicleChangeDriver(user: User, securityStudyValidation: boolean): void {
    this.spinner.show();
    this.vehiclesService.vehicleChangeDriver(this.relatedInfo.vehicle.id, user, securityStudyValidation).toPromise()
      .then((success: User) => {
        const data = this.userManager.sanitizeUser(success, Roles.DRIVER);
        if (data) {
          if (data.errorRNDC && data.errorRNDC && data.errorRNDC.error === 'Debe ingresar un conductor diferente al actual') {
            this.snackBarService.openSnackBar('Debe ingresar un conductor diferente al actual', undefined, 'alert');
          } else {
            this.snackBarService.openSnackBar('Conductor asignado correctamente');
            this.getDetailDriver();
          }
        } else {
          this.snackBarService.openSnackBar('Ocurrió un error al cambiar de conductor', undefined, 'error');
        }
      })
      .catch((error) => {
        this.snackBarService.openSnackBar('Ocurrió un error al cambiar de conductor', undefined, 'error');
      })
      .finally(() => {
        this.spinner.hide();
      });
  }

  private getDetailDriver(fromDialog: boolean = false): void {
    this.accountService.validateEntity(1, this.user.information.document).subscribe(
      async (data: User) => {
        if (this.utils.isDefined(data)) {
          this.onEdit.emit(this.relatedInfo.vehicle.id);
          this.user = data;
          if (!fromDialog) this.userStateByValidationRules = await this.adminUserService.getUserStateByValidationRules(this.user, Roles.DRIVER);
          this.user.role = this.role;
          this.getURlPictureUser(this.user.profilePicture);
        } else {
          this.setDefaultDriver();
        }
      },
      (error) => {
        this.setDefaultDriver();
      }
    );
  }

  private setDefaultDriver(): void {
    this.user = {
      information: {
        document: this.relatedInfo && this.relatedInfo.cargo ? this.relatedInfo.cargo.driver : '--'
      }
    };
  }

  public get scoreDriver(): number | number[] {
    try {
      return Array(Math.round(this.user.teclogiScore.globalScore)).fill(0).map((x, i) => i);
    } catch (e) {
      return 0;
    }
  }

  public get isDriver(): boolean {
    return this.role === this.roles.DRIVER;
  }

  public get showCheckValidation(): boolean {
    return (this.isDriver) ||
      (this.authService && this.authService.getCompany() && this.authService.getCompany().companyId !== environment.rootNit && !!(this.relatedInfo && this.relatedInfo.vehicle && this.relatedInfo.vehicle.administrator) && this.role === Roles.ADMIN && this.relatedInfo.vehicle.administrator.documentTypeId && this.relatedInfo.vehicle.administrator.documentTypeId !== '3') ||
      (this.authService && this.authService.getCompany() && this.authService.getCompany().companyId !== environment.rootNit && !!(this.relatedInfo && this.relatedInfo.vehicle && !this.relatedInfo.vehicle.administrator && ((this.relatedInfo.vehicle.driver && this.relatedInfo.vehicle.driver.document && this.relatedInfo.vehicle.owner && this.relatedInfo.vehicle.owner.document !== this.relatedInfo.vehicle.driver.document) || (!this.relatedInfo.vehicle.driver))) && this.role === Roles.OWNER && this.relatedInfo.vehicle.owner.documentTypeId && this.relatedInfo.vehicle.owner.documentTypeId !== '3');
  }

  public get showCheckValidationIndividual(): boolean {
    return this.authService && this.authService.getCompany().companyId === environment.rootNit && !this.isDriver && (
      (!!(this.relatedInfo && this.relatedInfo.vehicle && this.relatedInfo.vehicle.administrator) && this.role === Roles.ADMIN && this.relatedInfo.vehicle.administrator.documentTypeId && this.relatedInfo.vehicle.administrator.documentTypeId !== '3') ||
      (!!(this.relatedInfo && this.relatedInfo.vehicle && !this.relatedInfo.vehicle.administrator && (
        (this.relatedInfo.vehicle.driver && this.relatedInfo.vehicle.driver.document && this.relatedInfo.vehicle.owner && this.relatedInfo.vehicle.owner.document !== this.relatedInfo.vehicle.driver.document) ||
        (!this.relatedInfo.vehicle.driver)
      )) && this.role === Roles.OWNER && this.relatedInfo.vehicle.owner.documentTypeId && this.relatedInfo.vehicle.owner.documentTypeId !== '3'));
  }

  public canEditAdmin() {
    return this.permissionRole.hasPermission(
      this.permission.administration.module,
      this.permission.administration.editAdminVehicle
    );
  }

  get showDriverDetail(): boolean {
    return this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.readDriverDetails);
  }

}
